import { injectIntl } from "react-intl";
import React, { useEffect, useState } from "react";
import Header from "./Header";
import TopOffersTable from "./TopOffersTable";
import TopSMSEmailTable from "./TopSMSEmailTable";
import RevenueCard from "./RevenueCard";
import apiService from "src/services/api.service";
import { ListType } from "src/helpers/Enums";

const Dashboard = () => {
  const [smsList, setSmsList] = useState([]);
  const [emailList, setEmailList] = useState([]);
  const [smsOfferList, setSmsOfferList] = useState([]);
  const [emailOfferList, setEmailOfferList] = useState([]);
  const [lastMonthSummary, setLastMonthSummary] = useState([]);
  const [monthlySummary, setMonthlySummary] = useState([]);

  useEffect(() => {
    apiService
      .getTopList(ListType.SMS)
      .then((response) => setSmsList(response.data));
    apiService
      .getTopList(ListType.Email)
      .then((response) => setEmailList(response.data));
    apiService
      .getTopOffers(ListType.SMS)
      .then((response) => setSmsOfferList(response.data));
    apiService
      .getTopOffers(ListType.Email)
      .then((response) => setEmailOfferList(response.data));
    apiService
      .getLastMonthSummary()
      .then((response) => setLastMonthSummary(response.data));
    apiService
      .getMonthlySummary()
      .then((response) => setMonthlySummary(response.data));
  }, []);

  return (
    <div className={"Page"}>
      <Header></Header>
      <div className="DashboardTablesWrapper">
        <RevenueCard
          title={"Last Week Daily Average"}
          item={lastMonthSummary}
          type={null}
        ></RevenueCard>
        <RevenueCard
          title={"Weekly SMS Average"}
          item={monthlySummary}
          type={"SMS"}
        ></RevenueCard>
        <RevenueCard
          title={"Weekly Email Average"}
          item={monthlySummary}
          type={"Email"}
        ></RevenueCard>
      </div>
      <div className="DashboardTablesWrapper">
        <TopOffersTable title={"Email"} list={emailOfferList}></TopOffersTable>
        <TopOffersTable title={"SMS"} list={smsOfferList}></TopOffersTable>
      </div>
      <div className="DashboardTablesWrapper">
        <TopSMSEmailTable title={"Email"} list={emailList}></TopSMSEmailTable>
        <TopSMSEmailTable title={"SMS"} list={smsList}></TopSMSEmailTable>
      </div>
    </div>
  );
};

export default injectIntl(Dashboard);
